import { createAsyncThunk } from '@reduxjs/toolkit';

import { SettingsService } from 'api';

export const getGlobals = createAsyncThunk('settings/globals', async () => {
	return await SettingsService.getGlobals();
});
